export interface ReportDateRange {from:string;to:string;}
function localDate(date:Date):string {
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
}
/** Presets describe the user's calendar, including the hours before UTC midnight. */
export function reportDatePresets(now=new Date()):Record<string,ReportDateRange> {
  const day=(offset:number)=>{const date=new Date(now);date.setDate(date.getDate()+offset);return localDate(date);};
  return {today:{from:day(0),to:day(0)},yesterday:{from:day(-1),to:day(-1)},last7:{from:day(-7),to:day(-1)},last30:{from:day(-30),to:day(-1)}};
}
export function isReportDateRange(value:unknown):value is ReportDateRange {
  if(!value||typeof value!=='object'||!('from' in value)||!('to' in value))return false;
  const valid=(date:unknown):date is string=>typeof date==='string'&&/^\d{4}-\d{2}-\d{2}$/.test(date)&&Number.isFinite(Date.parse(date))&&new Date(date).toISOString().slice(0,10)===date;
  return valid(value.from)&&valid(value.to)&&value.from<=value.to;
}
